const PHONE_PATTERN = /^0\d{9}$/;
const PASSWORD_ALLOWED_PATTERN =
  /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]+$/;
const PASSWORD_REPEAT_PATTERN = /(.)\1{2,}/;

export function isValidPhone(phone) {
  if (!phone) return true;
  return PHONE_PATTERN.test(String(phone).trim());
}

export function getPasswordValidationErrors(password) {
  const errors = [];
  if (!password || password.length < 8) {
    errors.push("PasswordMinLength");
  }
  if (password && !PASSWORD_ALLOWED_PATTERN.test(password)) {
    errors.push("PasswordEnglishOnly");
  }
  if (password && !/\d/.test(password)) {
    errors.push("PasswordNeedNumber");
  }
  if (password && (!/[A-Z]/.test(password) || !/[a-z]/.test(password))) {
    errors.push("PasswordNeedCase");
  }
  if (password && PASSWORD_REPEAT_PATTERN.test(password)) {
    errors.push("PasswordNoTripleRepeat");
  }
  return errors;
}

export function isPasswordStrong(password) {
  return getPasswordValidationErrors(password).length === 0;
}

export function getPasswordStrength(password) {
  if (!password) return "Weak";
  const errors = getPasswordValidationErrors(password);
  if (errors.length > 0) return "Weak";

  const hasSymbols = /[^A-Za-z0-9]/.test(password);
  if (hasSymbols && password.length >= 10) return "Strong";
  return "Medium";
}

export function getStrengthValue(strength) {
  if (strength === "Weak") return 30;
  if (strength === "Medium") return 60;
  if (strength === "Strong") return 100;
  return 0;
}

export const PASSWORD_RULE_KEYS = [
  "PasswordMinLength",
  "PasswordEnglishOnly",
  "PasswordNeedNumber",
  "PasswordNeedCase",
  "PasswordNoTripleRepeat",
];
